interface Props {
  activeType: string;
  activeStatus: string;
  search: string;
  onTypeChange: (v: string) => void;
  onStatusChange: (v: string) => void;
  onSearchChange: (v: string) => void;
  total: number;
}

const TYPE_FILTERS = [
  { value: '', label: 'Alles' },
  { value: 'blueprint', label: 'Blueprints' },
  { value: 'consultation', label: 'Consulten' },
];

const STATUS_FILTERS = [
  { value: '', label: 'Alle statussen' },
  { value: 'paid', label: 'Betaald' },
  { value: 'unpaid', label: 'Niet betaald' },
  { value: 'blueprint_pending', label: 'Blueprint uitstaand' },
];

export const AdminFilters = ({
  activeType,
  activeStatus,
  search,
  onTypeChange,
  onStatusChange,
  onSearchChange,
  total,
}: Props) => (
  <div className="flex flex-col lg:flex-row items-start lg:items-center gap-3 mb-5">
    {/* Search */}
    <div className="relative flex-1 min-w-0 w-full lg:max-w-xs">
      <div className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center pointer-events-none">
        <i className="ri-search-line text-white/30 text-sm" />
      </div>
      <input
        type="text"
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
        placeholder="Zoek op e-mail, naam, bestelnr..."
        className="w-full pl-9 pr-4 py-2.5 bg-white/5 border border-violet-500/15 rounded-xl text-sm text-white placeholder-white/25 focus:outline-none focus:border-violet-500/40 transition-colors"
      />
    </div>

    {/* Type filter */}
    <div className="flex items-center gap-1.5 bg-white/5 border border-violet-500/15 rounded-xl p-1">
      {TYPE_FILTERS.map((f) => (
        <button
          key={f.value}
          onClick={() => onTypeChange(f.value)}
          className={`px-3 py-1.5 rounded-lg text-xs font-medium transition-all cursor-pointer whitespace-nowrap ${
            activeType === f.value
              ? 'bg-violet-600 text-white'
              : 'text-white/50 hover:text-white'
          }`}
        >
          {f.label}
        </button>
      ))}
    </div>

    {/* Status filter */}
    <select
      value={activeStatus}
      onChange={(e) => onStatusChange(e.target.value)}
      className="px-3 py-2.5 bg-white/5 border border-violet-500/15 rounded-xl text-sm text-white/70 focus:outline-none focus:border-violet-500/40 transition-colors cursor-pointer"
    >
      {STATUS_FILTERS.map((f) => (
        <option key={f.value} value={f.value} className="bg-[#110020]">
          {f.label}
        </option>
      ))}
    </select>

    <span className="text-white/30 text-xs whitespace-nowrap ml-auto">
      {total} resultaten
    </span>
  </div>
);
